import { useTranslations } from 'next-intl';
import { useCallback } from 'react';

export function useFormatCurrency(): (currency: { id: string; name?: string | null }) => string {
  const t = useTranslations('dictionaries.currency');

  return useCallback(
    (currency) => {
      return currency.id === '' ? t('all') : currency.name || currency.id;
    },
    [t]
  );
}
